module.exports = __webpack_public_path__ + "img/postgresql.50156c71.png";